import { render, staticRenderFns } from "./InhouseProfessionals.vue?vue&type=template&id=3a4f072a&"
import script from "./InhouseProfessionals.vue?vue&type=script&lang=ts&"
export * from "./InhouseProfessionals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports